import { computed, ref, watch } from 'vue';

export function useCesionEventSelection({
    abonadoId,
    router,
    selectedEvento,
    eventoWithMultipleSessions,
    showSessionPicker,
    errorEvento,
    onSelectEventoFromList,
    selectSessionFromPicker,
}) {
    const resolvingEventoId = ref(null);
    const expandedEventoId = ref(null);
    const selectionErrorEventoId = ref(null);

    const expandedSessions = computed(() => {
        if (!eventoWithMultipleSessions.value?.sesiones) {
            return [];
        }

        return Array.isArray(eventoWithMultipleSessions.value.sesiones)
            ? eventoWithMultipleSessions.value.sesiones
            : [];
    });

    function resetInlineSelectionState() {
        expandedEventoId.value = null;
        selectionErrorEventoId.value = null;
    }

    function closeExpandedSelection() {
        showSessionPicker.value = false;
        resetInlineSelectionState();
    }

    function markSelectionError(eventoId) {
        selectionErrorEventoId.value = eventoId;
    }

    function navigateToDetail() {
        if (!selectedEvento.value) {
            return;
        }

        router.push({
            name: 'ceder-asiento-detalle',
            params: {
                abono_id: abonadoId.value,
                evento_id: selectedEvento.value.eventoId,
                sesion_id: selectedEvento.value.sesionId
            }
        });
    }

    async function onSelectEvento(evento) {
        if (!evento?.id) {
            return;
        }

        if (showSessionPicker.value && expandedEventoId.value === evento.id) {
            closeExpandedSelection();
            return;
        }

        resolvingEventoId.value = evento.id;
        resetInlineSelectionState();

        try {
            await onSelectEventoFromList(evento);

            if (showSessionPicker.value) {
                expandedEventoId.value = evento.id;
                return;
            }

            if (errorEvento.value) {
                markSelectionError(evento.id);
            }
        } finally {
            resolvingEventoId.value = null;
        }
    }

    async function onSelectSession(sesionId) {
        const currentEventoId = expandedEventoId.value;

        resolvingEventoId.value = currentEventoId;
        closeExpandedSelection();

        try {
            await selectSessionFromPicker(sesionId);

            if (errorEvento.value) {
                markSelectionError(currentEventoId);
            }
        } finally {
            resolvingEventoId.value = null;
        }
    }

    watch(selectedEvento, newValue => {
        if (newValue) {
            navigateToDetail();
        }
    });

    return {
        resolvingEventoId,
        expandedEventoId,
        selectionErrorEventoId,
        expandedSessions,
        onSelectEvento,
        onSelectSession,
    };
}
